import styled from "styled-components";
import { heights } from "../../../util/mediaConstants";
import { Type } from "@ebscois/react-component-library";

export const Header = styled.div`
  position: fixed;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  max-width: 100%;
  top: ${heights.mfeHeader.sm}rem;
  left: 0;
  z-index: ${({ theme }) => theme.zIndex.appBarFixed};
  box-shadow: rgba(0, 0, 0, 0.5) 0px -1px 4px 0px;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    top: ${heights.mfeHeader.md}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    top: ${heights.mfeHeader.lg}rem;
  }

  @media print {
    display: none;
  }
`;

export const TocMenuButton = styled.button`
  display: flex;
  flex: 0 0 auto;
  align-self: start;
  margin-right: 0.5rem;
  padding: 0;
  border: 0;
  border-radius: 3px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.quinary.base};

  @media print {
    display: none;
  }

  &&&& {
    color: ${({ theme }) => theme.colors.gray800};
    fill: ${({ theme }) => theme.colors.gray800};
  }
`;

export const SectionButtonsWrapper = styled.div`
  flex: 0 0 auto;
  margin-left: auto;
  display: flex;
  align-items: center;
  align-self: start;
  justify-content: flex-end;
`;

export const TruncatedTitle = styled(Type)`
  font-size: ${({ theme }) => theme.font.size.xs};
  color: ${({ theme }) => theme.colors.gray800};
  line-height: 2;

  max-width: 31rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: 45rem;
    line-height: ${(props) => props.theme.line.height.base};
    font-size: ${({ theme }) => theme.font.size.sm};
  }
`;
